import { render, staticRenderFns } from "./B2CPlans.html?vue&type=template&id=732b20c7&external"
import script from "./B2CPlans.vue?vue&type=script&lang=js"
export * from "./B2CPlans.vue?vue&type=script&lang=js"
import style0 from "./B2CPlans.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports